export default __webpack_public_path__ + "static/media/070_boost.last.e18b1348.png";